import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  handleError: ['error'],
  setError: ['error'],
});

export { Types };
export default Creators;
